import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tmax-height: 50vh;\n\tpadding: ", ";\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmax-height: 50vh;\n\tmin-height: 24px;\n\toutline: none;\n\tposition: absolute;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tmin-width: 200px;\n\topacity: 0;\n\ttransform-origin: top center;\n\ttransition: opacity ", " ease;\n\n\t&[data-enter] {\n\t\topacity: 1;\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, ui } from '@wp-g2/styles';
export var DropdownMenu = css(_templateObject(), ui.zIndex('Dropdown', 9998), ui.get('transitionDurationFastest'));
export var Card = css(_templateObject2(), ui.zIndex('Dropdown'));
export var Scrollable = css(_templateObject3(), ui.space(1));